<template>
  <div class="ai-assistant">
    <assistant-sidebar />
  </div>
</template>

<script>
import assistantService from '@/ai/services/AssistantService'
import AssistantSidebar from './AssistantSidebar.vue'

export default {
  name      : 'AiAssistant',
  components: {
    AssistantSidebar
  },

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  async created () {
    if (assistantService.accountFeatures.includes('CORPORATE_AGENT')) {
      await assistantService.newSession()
    }
  }
}

</script>

<style scoped>
.ai-assistant {
  position: absolute;

  top: 0;
  right: 0;
  bottom: 0;

  z-index: 20;

  display: flex;

  height: 100%;
  min-height: 0;

  overflow: hidden;

  pointer-events: none;
}

.ai-assistant > * {
  pointer-events: auto;
}
</style>
